import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, FullPageSpinner } from 'admin-components/components';
import { useQuery } from '@apollo/client';
import { GET_BOOKING } from 'store/queries';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { currencyShape } from 'constants/propTypes';

const GetBookingQuery = ({ reference, children, query = GET_BOOKING, currency = null, centerLoader = false }) => {
  const variables = { reference };

  if (currency) {
    variables.currency = currency;
  }

  const { loading, data, error, refetch } = useQuery(query, {
    variables,
    fetchPolicy: 'network-only'
  });

  if (loading && centerLoader) {
    return <FullPageSpinner />;
  }

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/search/booking'
    });
  }

  const { booking } = data;

  return children(booking, refetch);
};

GetBookingQuery.propTypes = {
  children: PropTypes.func.isRequired,
  reference: PropTypes.string.isRequired,
  query: PropTypes.shape(),
  currency: currencyShape,
  centerLoader: PropTypes.bool
};

export default GetBookingQuery;
